import { Http } from '@/lib/http';

export class EscalationService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/escalation/';
  }

  getEfficiencyScoreBands() {
    return this.httpClient().get(`${this.endpoint}efficiency-score-bands`);
  }
  createEfficiencyScoreBand(payload) {
    return this.httpClient().post(
      `${this.endpoint}efficiency-score-bands`,
      payload
    );
  }
  updateEfficiencyScoreBand({ id, payload }) {
    return this.httpClient().put(
      `${this.endpoint}efficiency-score-bands/${id}`,
      payload
    );
  }

  removeEfficiencyScoreBand(id) {
    return this.httpClient().delete(
      `${this.endpoint}efficiency-score-bands/${id}`
    );
  }

  getEscalationTriggerScores() {
    return this.httpClient().get(`${this.endpoint}trigger-scores`);
  }

  getPaginatedEscalationTriggerScores(params) {
    return this.httpClient().get(`${this.endpoint}trigger-scores/paginated`, { params });
  }

  createEscalationTriggerScore(payload) {
    return this.httpClient().post(`${this.endpoint}trigger-scores`, payload);
  }

  updateEscalationTriggerScore({ id, payload }) {
    return this.httpClient().put(
      `${this.endpoint}trigger-scores/${id}`,
      payload
    );
  }

  removeEscalationTriggerScore(id) {
    return this.httpClient().delete(`${this.endpoint}trigger-scores/${id}`);
  }

  setAllEscalationActiveStatus({ active }) {
    return this.httpClient().patch(`${this.endpoint}update-status`, {
      active
    });
  }

  findEscalationWarningDays() {
    return this.httpClient().get(`${this.endpoint}escalation-warning-days`);
  }

  updateEscalationWarningDays(payload) {
    return this.httpClient().put(
      `${this.endpoint}escalation-warning-days`,
      payload
    );
  }
}
